const getBlogMigrationStatus = (state: AnyFixMe) => state.blog.migrationStatus;
export { getBlogMigrationStatus };
